// extracted by mini-css-extract-plugin
module.exports = {"small":"Loader_small__2r5Pe","medium":"Loader_medium__110gb","large":"Loader_large__34-nr"};